import { InteractiveMarker } from "common/Map/InteractiveMarker";
import { iconTypes } from "common/Map/Marker/iconTypes";
import { NativeClickImg } from "common/Map/NativeClickImg";
import { showGallery } from "features/gallery/showGallery";
import { urls } from "lib/urls";
import moment from "moment";
import React, { Fragment } from "react";
import styles from "./PhotoLayer.scss";

const PhotoPopup = ({ photo, launchGallery }) => (
  <div className={styles.PhotoPopup}>
    <div className={styles.thumb}>
      <NativeClickImg
        src={urls.photos.milli(photo.id)}
        height={64}
        width={64}
        onClick={() => launchGallery(photo.id)}
      />
    </div>
    <div>
      <div className={styles.metaLabel}>Photo taken</div>
      <div className={styles.metaValue}>{moment(photo.capturedAt).format("MMMM M, h:mm A")}</div>
    </div>
  </div>
);

const PhotoMarker = ({ photo, launchGallery }) => {
  if (!photo.lat || !photo.lng) return null;

  const icon = iconTypes.photo;
  const popupOffset = [0, -5 - icon.iconSize[1]];

  return (
    <InteractiveMarker
      id={`photo-${photo.id}`}
      icon={icon}
      popupOffset={popupOffset}
      position={{ lat: photo.lat, lng: photo.lng }}
      hoveredPopup={<PhotoPopup photo={photo} launchGallery={launchGallery} />}
    />
  );
};

export const PhotoLayer = ({ photos, ...props }) => (
  <Fragment>
    {photos &&
      photos.map((p) => (
        <PhotoMarker
          photo={p}
          key={p.id}
          launchGallery={(id) => showGallery({ photos, activePhotoId: id })}
          {...props}
        />
      ))}
  </Fragment>
);
